import styled from "styled-components";

export const Description = styled.p`
  ${({ theme }) => theme.font.body.sm};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  color: ${({ theme, dark }) =>
    dark ? theme.colors.neutral.gray8 : theme.colors.primary.cetaceanBlue};
`;
